import VesselTrafficLegend from './vessel-traffic-legend.component'

export default VesselTrafficLegend